import { useFormik } from "formik";
import { useContext, useState } from "react";

import { offer_id, offer_name, tag_id, tag_name } from "../../../constants";
import { mapStates } from "../../../constants/mapRegions";
import { Context } from "../../../context/context";
import LeadService from "../../../services/leadService";
import { validLeadConvert } from "../../../services/leadValidation";
import sessionTracking from "../../../services/sessionTracking";
import { userQlFlow } from "../../../services/userQLFlow";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { getCookie } from "../../../utils/cookie";

const useContactUs = () => {
  const state = useContext(Context);
  const { showSnackbar, updateUserQlData, showReviewStoryDrawer } =
    useContext(Context);
  const [loading, setLoading] = useState(false);
  const [vehicleDetails, setVehicleDetails] = useState({});
  let cacheInfo = getCookie("user_verified")
    ? JSON.parse(getCookie("user_verified"))
    : "";

  const form = useFormik({
    validateOnChange: true,
    initialValues: {
      name: cacheInfo?.name ?? "",
      mobile: cacheInfo?.phone ?? "",
      vehicle: "none",
      state: "none",
    },

    validate: (values) => {
      const errors = { ...values?.errors };

      if (!values?.mobile?.toString()) {
        errors.mobile = "Mobile Number is Mandatory";
      }
      if (values?.mobile?.toString()?.length !== 10) {
        errors.mobile = "Enter a valid 10 digit Mobile Number";
      }
      if (values?.mobile && values?.mobile[0] < 5) {
        errors.mobile = "Enter Valid Mobile Number";
      }
      if (values?.name?.toString()?.length === 0) {
        errors.name = "Please Enter Your Name";
      }

      const ipInformation = localStorage.getItem("geoLocation")
        ? JSON.parse(localStorage.getItem("geoLocation"))
        : {};

      if (values?.mobile?.toString()?.length === 10) {
        let payload = {
          phoneNumber: values?.mobile,
          connectType: "contactus_form",
          type: "contactus_form",
          cityInfo: ipInformation?.city,
          geoInfo: ipInformation,
        };
        sendAnalytics("v2_lead_form_entered_mobile", payload, "en");

        const leadPayload = {
          name: "",
          phone: values?.mobile,
          state: mapStates[ipInformation?.countryRegion] ?? "Others",
          leadIntent: "HIGH_INTENT",
          subSource: "Contact Us",
        };

        // param: leadpayload, analyticsPayload
        validLeadConvert(leadPayload, payload);
      }

      return errors;
    },

    onSubmit: (values) => {
      let analytics_payload = {
        vehicle_name: vehicleDetails?.name ?? "",
        vehicle_id: vehicleDetails?.vehicle_id ?? "",
        emi_shown: vehicleDetails?.emiPrice ?? "",
        price_shown: vehicleDetails?.price ?? "",
        offer_name: offer_name,
        offer_id: offer_id,
        tag_name: tag_name,
        tag_id: tag_id,
        user_name: values.name,
        phone_number: values.mobile,
        state: state.selectedState,
        button_trigger_location: "Contact us",
        type: "contactus_form",
        is_otp_verified: state?.leadVerifiedStatus,
      };
      sendAnalytics("contact_us_clicked", analytics_payload, "en");
      let payload = {
        name: values?.name ?? "",
        phone: values.mobile,
        pan: "",
        pincode: "",
        dob: "",
        state: values?.state ?? "Unknown",
        optedExchange: "",
        vehicleSelected: values.vehicle,
        language: "en",
        refNumber: "",
        leadIntent: "",
        subSource: "Contact Us",
        verified: state?.leadVerifiedStatus,
      };

      setLoading(true);

      LeadService(payload)
        .then((response) => {
          const sessionInfo = {
            leadUuid: response?.data?.uuid,
            newSession: true,
            formSubmitted: true,
            leadIntent: "LOW_INTENT",
          };

          sessionTracking(sessionInfo);
          showSnackbar("We will get back to you soon!!", "success");
          setLoading(false);

          // Enable QL Lead flow
          userQlFlow(state, updateUserQlData, showReviewStoryDrawer);
        })
        .catch((error) => {
          showSnackbar(
            "Oops, something went wrong. Please try again later.",
            "error"
          );
        });
    },
  });
  return {
    form,
    loading,
    setVehicleDetails,
  };
};

export default useContactUs;
